var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container record" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n        お客様の投資申込を受付けいたしました\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "b1" }, [
      _vm._v(
        "\n        お申込み金額をお振込み下さい（本日より５営業日以内）。\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrap" },
      _vm._l(_vm.descList, function (item) {
        return _c("div", { key: item.label, staticClass: "wrap-item" }, [
          _c("div", { staticClass: "left" }, [
            _vm._v(
              "\n                " + _vm._s(item.label) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _vm._v("\n                " + _vm._s(item.text) + "\n            "),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "btn", on: { click: _vm.onNext } }, [
      _vm._v("\n        取引履歴>>>\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }